// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBGtXNPdqfUeMSgLDNJrzoBb39tXljQrSQ",
  authDomain: "react-social-a77ea.firebaseapp.com",
  projectId: "react-social-a77ea",
  storageBucket: "react-social-a77ea.appspot.com",
  messagingSenderId: "359813550703",
  appId: "1:359813550703:web:4b2b33123cde3e4324b39a",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
